function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M99.696,2.386L44.344,57.737c-3.377,3.377-3.377,8.854,0,12.231c3.378,3.378,8.854,3.378,12.231,0l40.587-40.587v147.825 c0,4.775,3.872,8.648,8.649,8.648c4.776,0,8.648-3.873,8.648-8.648V29.381l40.587,40.585c3.378,3.378,8.854,3.378,12.231,0 c1.687-1.689,2.533-3.902,2.533-6.115c0-2.214-0.847-4.427-2.533-6.116L111.927,2.386C108.549-0.992,103.073-0.992,99.696,2.386z"
}));

var SvgArrowTop = function SvgArrowTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "186.002px",
    viewBox: "41.814 -0.147 128 186.002",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-top.e5e4a5c2.svg";
export { ForwardRef as ReactComponent };